module.exports = __webpack_public_path__ + "img/login-main-bg.7d958901.svg";